import React from 'react'
import styled from '@emotion/styled'
import cn from 'classnames'
import { SelectableItem } from 'shared/ui'
import LabelText from './LabelText'
import LabelCheckbox from './LabelCheckbox'

const ListItem = ({
  className,
  isChecked,
  isFocused,
  label: { id, color, name, labelingsCount: count },
  onCheckboxClick = null /* When checkbox input changed */,
  onClick = null /* when row/label or checkbox input clicked */,
  showCount,
}) => {
  return (
    <SelectableItem
      className={cn('grui py-4 pl-12 pr-10', className)}
      content={
        <LabelCheckbox
          checked={isChecked}
          id={id}
          label={<LabelText name={name} count={count} showCount={showCount} />}
          inputColor={color}
          name={name}
          onCheckboxClick={onCheckboxClick}
        />
      }
      onContainerClick={onClick}
      selected={isFocused}
    />
  )
}

export default styled(ListItem)`
  display: block;
`
